<template>
  <draggable
    :list="items"
    handle="#drag-zone"
    item-key="id"
    @change="
      emit('update:list');
      emit('htmlStringEdited');
    "
  >
    <template #item="{ element }">
      <ItemActionCard
        v-if="element.type !== ItemType.Footer"
        :key="element.id"
        :item="element"
        :templateType="templateType"
        :selected="selectedItem?.id === element.id"
        @click:add="handleAdd"
        @click:copy="handleCopy"
        @click:delete="handleDelete"
        @click:settings="handleSettings"
        @htmlStringEdited="emit('htmlStringEdited')"
      />
    </template>
  </draggable>

  <ItemActionCard
    v-if="footerItem"
    :item="footerItem"
    :templateType="templateType"
    :selected="selectedItem?.id === footerItem.id"
    @click:settings="handleSettings"
    @htmlStringEdited="emit('htmlStringEdited')"
  />
</template>

<script setup lang="ts">
import { inject, Ref, computed } from "vue";
import draggable from "vuedraggable";

import { ItemType, TemplateItem } from "@/@types/flows/emailTemplates/items";
import { TemplateItemsManager } from "@/app/flows/emailTemplates/utils/TemplateItemsManager";
import { TemplateType } from "@/@types/flows/emailTemplates";

import ItemActionCard from "@/app/flows/emailTemplates/components/cards/ItemActionCard.vue";

const props = defineProps<{ items: TemplateItem[]; templateType: TemplateType }>();

const emit = defineEmits<{
  openDrawer: [drawer: { action: "add" | "edit"; item?: TemplateItem }];
  htmlStringEdited: [];
  "update:list": [];
}>();

const footerItem = computed(() => props.items.find((i) => i.type === ItemType.Footer));

const selectedItem = inject("selectedItem") as Ref<TemplateItem | undefined>;

const handleAdd = () => emit("openDrawer", { action: "add" });

const handleCopy = (item: TemplateItem) => {
  TemplateItemsManager.copyItem(item);
  emit("htmlStringEdited");
};

const handleDelete = (item: TemplateItem) => {
  TemplateItemsManager.removeItem(item.id);
  emit("htmlStringEdited");
};

const handleSettings = () => emit("openDrawer", { action: "edit", item: selectedItem.value });
</script>

<style scoped lang="sass"></style>
